import * as React from 'react';
import type { HashRouterProps, RedirectProps, RouteProps, SwitchProps } from 'react-router-dom';
import {
    HashRouter as RRHashRouter,
    Redirect as RRDRedirect,
    Route as RRDRoute,
    Switch as RRDSwitch,
} from 'react-router-dom';

/**
 * react-router-dom v5 中 Route/Switch/Redirect 基于旧版 Component 类型声明，
 * 与 React 18 的 @types/react 中 JSX 对类实例的校验不兼容（TS2786：缺少 refs 等）。
 * 断言为 ComponentType 后可在 TS 下正常作为 JSX 使用，运行时不变。
 */
export const Route = RRDRoute as unknown as React.ComponentType<RouteProps>;
export const Switch = RRDSwitch as unknown as React.ComponentType<SwitchProps>;
export const Redirect = RRDRedirect as unknown as React.ComponentType<RedirectProps>;
export const HashRouter = RRHashRouter as unknown as React.ComponentType<HashRouterProps>;
